import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { animationDefault } from '../../containers/editor/scene-blocks/block-constants';
import { IAnimationEngine, IAnimationPreset, IIn, IOut, IPlay } from '../../interfaces';
import { PlayAnimations, InAnimations, OutAnimations } from 'assets/accountTemplates/animation-effect-constants';
import * as _ from "lodash";

@Component({
    selector: 'app-dialog-preset-animation',
    templateUrl: './dialog-preset-animation.component.html',
    styleUrls: ['./dialog-preset-animation.component.scss']
})
export class DialogPresetAnimationComponent implements OnInit {

    presettedAnimation: IAnimationEngine = null;
    isDialog = false;
    animationTemplates = {};
    duration = {};
    selection = {};
    mode: "In" | "Out" | "Play" = "In";
    modes = ["In", "Out", "Play"];

    @Output() selectAnimation: EventEmitter<any> = new EventEmitter<any>();
    @Input() disableUI = false;

    @Input()
    set resetAnimations(v) {
        if (v) {
            this.selection = {};
        } else {
            this.selection = {
                In: "Fade In",
                Out: "Fade Out",
                Play: null
            }
        }
    }

    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.duration = {
            In: 1,
            Out: 2,
            Play: 3
        };

        this.selection = {
            In: null,
            Out: null,
            Play: null
        }

        this.animationTemplates = {
            In: InAnimations,
            Out: OutAnimations,
            Play: PlayAnimations
        }

        if (data && data.animation) {
            this.presettedAnimation = data.animation;
        }

        if (data && (data.isDialog || data.mode)) {
            this.isDialog = true;
            this.mode = data.mode;
        }
    }

    ngOnInit(): void {
    }

    onSelectAnimation(item: IAnimationPreset): void {
        if (!item) return;
        this.selection[item.mode] = this.selection[item.mode] === item.name ? null : item.name;

        if (this.selectAnimation.observed) {
            this.onPresetAnimation();
            this.selectAnimation.emit(this.presettedAnimation);    
        }
    }

    onPresetAnimation() {
        if (!this.presettedAnimation) {
            this.presettedAnimation = _.cloneDeep(animationDefault[0]);
        }

        if (this.mode) {
            if (this.selection[this.mode]) {
                const animation = _.cloneDeep(this.animationTemplates[this.mode].find((item) => item.name === this.selection[this.mode]).animation);
                animation.$.duration = `${this.duration[this.mode] * 1000}`;
                this.presettedAnimation[this.mode] = [animation as (IIn & IPlay & IOut)];
            }
        } else {
            this.modes.map((_mode) => {
                if (this.selection[_mode]) {
                    const animation = _.cloneDeep(this.animationTemplates[_mode].find((item) => item.name === this.selection[_mode]).animation);
                    animation.$.duration = `${this.duration[_mode] * 1000}`;
                    this.presettedAnimation[_mode] = [animation as (IIn & IPlay & IOut)];
                }
            });
        }

        if (this.isDialog) {
            this.dialogRef.close(this.presettedAnimation);
        }
    }
}
